<template>
  <el-dialog title="添加协会" :append-to-body="true" :visible.sync="visible" :show-close="false" width="500px" :modal="true" :close-on-click-modal="false" :close-on-press-escape="false">
    <button type="button" aria-label="Close" class="el-dialog__headerbtn" @click.stop="cancelModal"><i
      class="el-dialog__close el-icon el-icon-close"></i></button>
    <el-form :model="association" size="small">
      <el-form-item label="上级协会" label-width="80px">
        {{name}}
      </el-form-item>
      <el-form-item label="名称" label-width="80px">
        <el-input v-model="association.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="地址" label-width="80px">
        <el-input v-model="association.address" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="联系方式" label-width="80px">
        <el-input v-model="association.phone" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button v-if="loading" type="primary" :loading="true">保存中</el-button>
      <el-button v-else type="primary" @click="save">保存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import association from '@/api/association'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    assId: {
      type: Number,
      required: false,
      default: null
    },
    pid: {
      type: Number,
      required: false,
      default: null
    },
    level: {
      type: Number,
      required: false,
      default: null
    },
    assName: {
      type: String,
      required: false,
      default: ''
    },
    status: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      // 协会
      name: '',
      association: {
        id: 0,
        name: '',
        code: '',
        address: '',
        phone: '',
        node: '',
        pid: null
      }
    }
  },
  methods: {
    initForm () {
      this.association = {
        }
      if (this.$refs.association) {
        this.$refs.association.resetFields()
      }
    },
    cancelModal () {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit('update:visible', false)
    },
    reload () {
      if (this.status !== 'add') {
        association.load({id: this.assId }).then(res => {
          this.association = res.data.data
        })
       if (this.pid !== 0){
         association.load({id: this.pid }).then(res => {
           console.log(res.data)
           this.name = res.data.data.name
         })
       }
      }else {
        this.name = this.assName
      }
    },
    save () {
      this.loading = true
      if (this.status === 'add') {
        //新增
        this.association.pid = this.assId
        this.association.grade = this.level + 1
      }
      // console.log(this.association)
      association.update(this.association).then(res => {
        this.loading = false
        this.$message.info(res.data.message)
        if (res.data.code === 0){
          this.$emit('update:visible', false)
          // parent.location.reload()
          this.$emit('callFather')
        }
      })
    }
  },
  created () {
    this.reload()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/lawyer/association/Ass.vue